module.exports = __webpack_public_path__ + "images/tidings-bom-imag-new.1790731042052.png";